<template>
  <Dialog
    v-model:visible="visibleDialog"
    :style="{ width: '580px' }"
    header="Configurações do Desenvolvedor"
    :modal="true"
    @hide="hideDialog"
  >
    <div class="p-fluid formgrid grid">
      <div class="p-fluid formgrid grid">
        <div class="field col-12 md:col-12">
          <label for="path">Diretório Principal</label>
          <InputText id="path" v-model="folder.project.path" disabled />
        </div>
        <div class="field col-12 md:col-12">
          <label for="subpath">Sub-Diretório</label>
          <InputText
            id="subpath"
            v-model="folder.subDirectory"
            placeholder="Digite o sub-path"
            disabled
          />
        </div>
        <div class="field col-12 md:col-12">
          <label for="subpath">Indentificador do Sub-Diretório </label>
          <InputText
            id="subpath"
            v-model="folder.identifier"
            placeholder="Digite o sub-path"
            autofocus
            disabled
          />
        </div>
        <div class="field col-12 md:col-12">
          <p>Cadastro</p>
          <p class="input-like">
            {{ $DateTime.formateToString(folder.dtCreate) }}
          </p>
        </div>

        <div class="field col-12 md:col-12">
          <label>Atualização</label>
          <p v-if="folder.dtUpdate === null" class="input-like">
            Sem Atualização.
          </p>
          <p v-else class="input-like">
            {{ $DateTime.formateToString(folder.dtUpdate) }}
          </p>
        </div>
      </div>
    </div>
    <template #footer> </template>
  </Dialog>
</template>
<script>
//Models
import Folder from "../../../models/folder";

//VALIDATIONS
export default {
  props: ["selected"],
  data() {
    return {
      folder: new Folder(),
    };
  },
  created() {},
  computed: {
    visibleDialog: {
      get() {
        let value = this.$store.state.views.folder.dialogConfig;
        if (value === true) this.getData();
        return value;
      },
      set(value) {
        this.$store.state.views.folder.dialogConfig = value;
      },
    },
  },
  methods: {
    hideDialog() {
      this.folder = new Folder();
      this.visibleDialog = false;
    },
    getData() {
      this.folder = this.selected;
    },
  },
};
</script>
<style scoped>
.input-like {
  border: 1px solid #ccc; /* Borda semelhante à de um input */
  border-radius: 7px; /* Cantos arredondados */
  padding: 6px; /* Espaçamento interno */
  outline: none; /* Remove o contorno ao focar */
  transition: border-color 0.3s, box-shadow 0.3s; /* Transições suaves */
}
.input-like:focus {
  border-color: #3498db; /* Altera a cor da borda ao focar */
  box-shadow: 0 0 5px rgba(52, 152, 219, 0.5); /* Sombra para destaque */
  background-color: #f9f9f9; /* Leve mudança de fundo ao focar */
}
</style>
